import { render, staticRenderFns } from "./Wifi.vue?vue&type=template&id=88073e1a&scoped=true"
import script from "./Wifi.vue?vue&type=script&lang=js"
export * from "./Wifi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88073e1a",
  null
  
)

export default component.exports